import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthBffService, ENVIRONMENT_ACCOUNT } from '@visiativ/digital-account-front';
import { catchError, throwError } from 'rxjs';

export const authErrorInterceptor: HttpInterceptorFn = (req, next) => {
	const environment = inject(ENVIRONMENT_ACCOUNT);
	const auth = inject(AuthBffService);

	const isGatewayRequest = req.url.startsWith(environment.gatewayUrl);
	// Les endpoints /auth/* gèrent eux-mêmes leurs 401 (init, login, logout) :
	// on les ignore ici pour éviter les redirections en double et les boucles.
	const isAuthEndpoint = req.url.includes('/auth/');

	if (!isGatewayRequest || isAuthEndpoint) {
		return next(req);
	}

	return next(req).pipe(
		catchError((error: unknown) => {
			// Un 401 n'est pas toujours lié à la session : AuthBffService le confirme avec /auth/me
			// avant de rediriger vers le login.
			void auth.handleUnauthorizedError(error);
			auth.handleAccountDisabledError(error);
			return throwError(() => error);
		}),
	);
};
